import React from 'react'
import CustomView from "../../../../../../core/model2/custom-view/custom-view"
import FormManager from "../../../../../../core/gd-form/common/form-manager"
import customViewFactory from "../../../../../../core/model2/custom-view/factory";
import {ViewAccess} from "../../../../../../core/gd/const/views/view-type-config";
import ApiProject from "../../../../../../core/gd/api/project";
import {CustomViewFormProps} from "../../../../../../views/info/sections/info/view-type-forms/base-view-form";

// import ViewModel from 'core/gd-model/custom-views/old/view-model'

export type BaseViewFormProps = {
    className?      : string
    organizationId? : ID
    mode            : 'create' | 'update'
    view            : CustomView
    onSubmit        : func
}

const debug = {
    dev: false,
    head: "BaseCustomViewForm"
}

export default class BaseViewForm<T extends BaseViewFormProps = BaseViewFormProps, S extends any = any> extends React.Component<T,S> {

    public viewType     : number | null
    public defaultName  : string | null
    public form         : FormManager | null

    constructor(props: T) {
        super(props)

        this.viewType = null;
        this.defaultName = null;
        this.form = null;
    }

    getViewInitFormData = (view: CustomView, moreInitFromData = {}) => {

        const initFormData = {
            access:                 0,
            sharedUsers:            [],
            companyId:              gd.companyId,
            name:                   this.defaultName,
            isPinned:               false,
            location:               'tools'
        };

        if (view) {
            initFormData.access =               view.access;
            initFormData.sharedUsers =          view.sharedUsers;
            initFormData.companyId =            gd.companyId || ''; //form value should be string
            initFormData.name =                 view.name;
            // initFormData.isPinned =             view.isPinned;
            initFormData.location =             view.location;
        }

        return _.assign(initFormData, moreInitFromData);
    };

    getViewFormFields = (moreFields = {}) => {
        return _.assign({
            access:                 { type: 'select',   isRequired: false,  label: 'Access'},
            sharedUsers:            { type: 'select',   isRequired: false,  label: 'Shared users'},
            companyId:              { type: 'select',   isRequired: false,   label: 'Company'},
            name:                   { type: 'input',    isRequired: true},
            isPinned:               { type: 'checkbox', isRequired: false},
            location:               { type: 'select',   isRequired: true},
        }, moreFields)
    };

    getUsers = () => {
        const projects = this.form?.hasField('projects') ? this.form.getValue('projects') : [];
        let users = projects.length === 0 ?
            gd.session.companyUsers.filterByCompanyAndRoles(gd.companyId).map((companyUser: any) => companyUser.user)
            :
            gd.session.projectUsers.filterByProjects(projects).map((pu: any) => pu.user);

        users = _.uniqBy(users, (u: any) => u.id)
        users = _.sortBy(users, (u: any) => u.name)
        return users.map((u: any) => u.id)
    };

    updateUsersField = (name: string) => {
        const users = this.form?.getValue(name);
        const newUsers = _.intersection(users, this.getUsers());
        this.form && this.form.setFieldValue(name, newUsers);
    };

    submitUpdate(formData: any, settings: any) {

        debug.dev && console.log(debug.head, ".submitUpdate", formData, settings);

        const { view } = this.props;

        // let companyId = formData.companyId;
        // // fix companyId value: from form value to settings value
        // if (!this.form.fields['companyId'].isRequired && companyId === '') {
        //     companyId = null;
        // }

        // const viewType = this.viewType;

        if (formData && formData.location) {
            view.location = formData.location;
        }


        view.name = formData.name;
        view.sharedUsers = formData.sharedUsers;
        view.access = formData.access;

        // set access to private if no shared users selected
        switch (formData.access) {
            case ViewAccess.PRIVATE: break; // do nothing, already private
            case ViewAccess.SHARED:
                if (!view.sharedUsers || view.sharedUsers.length === 0) view.access = ViewAccess.PRIVATE;
                break;
        }

        // save appSettings if defined
        if (view.settings && view.settings.appSettings) settings.appSettings = view.settings.appSettings;

        view.settings = settings;

        view.save().promise().then(() => {
            this.form?.setFieldValue('name', '');
            this.form?.reset();

            gd.bus.triggerEvent('gd.session.customViews:change');

            this.props.onSubmit && this.props.onSubmit();
        })


    }

    submitData = async (formData: any, settings: any) => {

        if (this.props.mode === 'update') {
            return this.submitUpdate(formData, settings);
        }

        // const { view } = this.props;

        let companyId = formData.companyId;
        // fix companyId value: from form value to settings value
        if (!this.form?.fields['companyId'].isRequired && companyId === '') {
            companyId = null;
        }

        // const viewType = this.viewType;
        const name = formData.name;
        // const isPinned = formData.isPinned;
        // const pinView = (customViewId: ID)=>{if (isPinned) gd.api.Pins.addPin({customViewId})}

        const sharedUsers = formData.sharedUsers;
        let access = formData.access;
        switch (formData.access) {
            case ViewAccess.PRIVATE: break; // do nothing, already private
            case ViewAccess.SHARED: if (sharedUsers.length === 0) access = ViewAccess.PRIVATE; break; // set access to private if no shared users selected
        }

        const params: any = {}
        if (formData && formData.location) {
            params.location = formData.location
        }


        if (this.props.view.inProjectStructure) {
            console.log("create view in projects structure", this.props.view)


            const response : any = await ApiProject.newView({
                name            : name,
                color           : 1,
                parentProjectId : this.props.view.parentProjectId,
                projectIcon     : 'view-table',
                settings        : {
                    customView      : {
                        settings        : settings,
                        type            : this.props.view.type
                    }
                }
            })

            console.log("p[roject view creted", response)

            // const newProject = gd.session.projects.get(response.projectId)
            gd.quickAdd.close()

            gd.navigation.goToProject(response.projectId)

            return
        }



        gd.api.Views.create(this.props.view.type, name, params, access, sharedUsers, settings).promise().then((data: any) => {
            this.form?.setFieldValue('name', '')
            this.form?.reset()

            // pinView(data.view.id)

            if (this.props.onSubmit) {
                const model = customViewFactory(data.view)
                // model.boardType = viewType
                this.props.onSubmit(model)
            }
        })

    }
}
